// extracted by mini-css-extract-plugin
export var badge = "_hy-2";
export var detailsPanel = "_hy-0";
export var resultRow = "_hy-1";